import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export const postCriarEtiqueta = async ({
  etiquetasCorretor,
}: {
  etiquetasCorretor: { id: string; nome: string; cor: string }[];
}): Promise<any> => {
  const url = `${leadsWebEnviroment}/commom/leads/etiquetas-corretor/v1`;
  const response = await instance.post(url, { etiquetasCorretor });

  return response?.data;
};
